export const initFormValidation = () => {
  const forms = document.querySelectorAll("form");

  forms.forEach((form) => {
    form.addEventListener("submit", (e) => {
      // Cancelled by the form's own validation (registered in the capture phase, so it runs
      // first): nothing is posted, keep the button usable
      if (e.defaultPrevented) {
        return;
      }

      const submitButton = form.querySelector('[type="submit"]') as HTMLButtonElement;

      if (submitButton) {
        // Do not post form twice
        if (form.beenSubmitted) {
          e.preventDefault();
          return false;
        }

        submitButton.disabled = true; // disable button

        submitButton.innerHTML =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>\n' +
          '  <span class="visually-hidden">Loading...</span>';
        form.beenSubmitted = true;
      }
    });
  });
};
